module.exports = __webpack_public_path__ + "static/media/revisao.a2173df7.svg";